import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/styles/global.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { CookiesProvider } from 'react-cookie';
import { AuthContextProvider } from './auth/AuthContext';
import { ThemeProvider } from './theme/ThemeContext';
import { PrimeReactProvider } from 'primereact/api';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <CookiesProvider>
        <AuthContextProvider>
          <ThemeProvider>
            <PrimeReactProvider value={{ unstyled: false, ripple: true, }}> {/* 🆕 */}
              <App />
            </PrimeReactProvider>
          </ThemeProvider>
        </AuthContextProvider>
      </CookiesProvider>
    </HashRouter>
  </React.StrictMode>
);

reportWebVitals();
